import React, { useEffect } from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

function Root() {

    useEffect(() => {

        /* =========================================================
           DISABLE TEXT SELECTION
        ========================================================= */

        document.body.style.userSelect = 'none';
        document.body.style.webkitUserSelect = 'none';
        document.body.style.mozUserSelect = 'none';
        document.body.style.msUserSelect = 'none';


        /* =========================================================
           DISABLE RIGHT CLICK
        ========================================================= */

        const disableContextMenu = (e) => {
            e.preventDefault();
        };


        /* =========================================================
           DISABLE COPY
        ========================================================= */

        const disableCopy = (e) => {
            e.preventDefault();
        };


        /* =========================================================
           DISABLE CUT
        ========================================================= */

        const disableCut = (e) => {
            e.preventDefault();
        };


        /* =========================================================
           DISABLE TEXT SELECTION
        ========================================================= */

        const disableSelect = (e) => {
            e.preventDefault();
        };


        /* =========================================================
           DISABLE DRAG
        ========================================================= */

        const disableDrag = (e) => {
            e.preventDefault();
        };


        /* =========================================================
           PREVENT MOBILE PULL-TO-REFRESH
        ========================================================= */

        let startY = 0;

        const handleTouchStart = (e) => {

            if (e.touches.length === 1) {
                startY = e.touches[0].clientY;
            }

        };


        const handleTouchMove = (e) => {

            if (e.touches.length !== 1) {
                return;
            }

            const currentY = e.touches[0].clientY;

            const deltaY = currentY - startY;


            /*
             * User is moving thumb DOWN.
             *
             * If the page is already at the top,
             * stop browser pull-to-refresh.
             */

            if (
                window.scrollY <= 0 &&
                deltaY > 0
            ) {
                e.preventDefault();
            }

        };


        /* =========================================================
           ADD EVENTS
        ========================================================= */

        document.addEventListener(
            'contextmenu',
            disableContextMenu
        );

        document.addEventListener(
            'copy',
            disableCopy
        );

        document.addEventListener(
            'cut',
            disableCut
        );

        document.addEventListener(
            'selectstart',
            disableSelect
        );

        document.addEventListener(
            'dragstart',
            disableDrag
        );


        /*
         * IMPORTANT:
         * passive:false allows preventDefault()
         * on mobile touchmove.
         */

        document.addEventListener(
            'touchstart',
            handleTouchStart,
            {
                passive: true
            }
        );

        document.addEventListener(
            'touchmove',
            handleTouchMove,
            {
                passive: false
            }
        );


        /* =========================================================
           CLEANUP
        ========================================================= */

        return () => {

            document.body.style.userSelect = '';
            document.body.style.webkitUserSelect = '';
            document.body.style.mozUserSelect = '';
            document.body.style.msUserSelect = '';


            document.removeEventListener(
                'contextmenu',
                disableContextMenu
            );

            document.removeEventListener(
                'copy',
                disableCopy
            );

            document.removeEventListener(
                'cut',
                disableCut
            );

            document.removeEventListener(
                'selectstart',
                disableSelect
            );

            document.removeEventListener(
                'dragstart',
                disableDrag
            );

            document.removeEventListener(
                'touchstart',
                handleTouchStart
            );

            document.removeEventListener(
                'touchmove',
                handleTouchMove
            );

        };

    }, []);


    return <App />;
}


const root = ReactDOM.createRoot(
    document.getElementById('root')
);


root.render(
    <React.StrictMode>
        <Root />
    </React.StrictMode>
);


reportWebVitals();